import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import GameColors from "../GameColors";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import Overlay from "../utils/Overlay";

export class GameCompleteScreen extends GameObject {
    index: number;
    scene: ResizableScene;
    onExit: () => void;
    context: CallbackContext;
    resize: () => void;

	constructor(scene: ResizableScene, onExit: () => void, context: CallbackContext) {
		super(scene);
        this.index = 0;
        this.scene = scene;
        this.onExit = onExit;
        this.context = context;

        const overlay = Overlay.create(scene);
        this.add(overlay);
		
		const spineContainer = scene.add.spineContainer(0, 0);
        this.add(spineContainer);
        
        const spawnFirework = () => {
            const spine = this.scene.add.spine(0, 0, "firework-burst", "burst", false);
            spine.setSkinByName(Phaser.Math.RND.pick(["blue", "red", "yellow"]));
            spine.setPosition(Phaser.Math.RND.realInRange(0, scene.viewport.width), Phaser.Math.RND.realInRange(0, scene.viewport.height));
            spine.scale = Phaser.Math.RND.realInRange(1, 1.2);
            spine.once("complete", () => {
                spine.destroy();
            });
            spineContainer.add(spine);
            this.scene.time.delayedCall(500, spawnFirework);
        };
        spawnFirework();

        const character = this.addImage("endingCharacter");
        const popupContainer = this.scene.add.container();
        this.add(popupContainer);
        const popup = this.addImage("endingPopup");
        popupContainer.setSize(popup.width, popup.height);
        const textBG = this.addImage("endingPopupBox");
        const logo = this.addImage("splashLogo");
        logo.scale = 0.5;

        const headerBacker = this.addImage("endingHeader");

        popupContainer.add([popup, textBG, logo, headerBacker]);

        const header =  scene.add.text(0, 0, Strings.get("GameCompleteHeader"), {
            fontFamily: Fonts.LuckiestGuy,
            fontSize: "80px",
            color: GameColors.WHITE,
        });
        header.setShadow(5, 5, GameColors.BLACK, 1, false, true);
        popupContainer.add(header);
        LayoutUtils.scaleToMaxWidth(header, 650);
        header.setSize(header.displayWidth, header.displayHeight);

        const text = scene.add.text(0, 0, Strings.get("GameCompleteDesc"), {
            fontFamily: Fonts.MaliMediumItalic,
            fontSize: "36px",
            color: GameColors.BLACK,
            align: "center",
            wordWrap: {width: 500}

        });
        popupContainer.add(text);

        const playBtn = scene.add.button(0, 0, "splashPlayButton", undefined, this.exit, this, true);
        popupContainer.add(playBtn);
        playBtn.scale = 0.85;

        this.resize = () => {
            overlay.setDisplaySize(scene.viewport.width, scene.viewport.height); 
            scene.alignIn.Center(overlay, scene.viewport);
           
            scene.alignIn.BottomLeft(character, scene.viewport, -50, 0);

            const screenRatio = scene.viewport.width/scene.viewport.height;
            const idealRatio = 16/9;
            let scale = 1;
            if (idealRatio - screenRatio > 0) scale = 1 - (idealRatio - screenRatio) * 0.7;
            popupContainer.setScale(scale);
            scene.alignIn.RightCenter(popupContainer, scene.viewport, -50 + (popupContainer.width - popupContainer.displayWidth) * 0.55, 80);

            scene.alignIn.Center(textBG, popup, 0, 0);
            scene.alignIn.TopCenter(logo, popup, 0, 350);
            scene.alignIn.Center(headerBacker, textBG, 0, -130);
            scene.alignIn.Center(header, headerBacker, 0, -15);
            scene.alignIn.Center(text, textBG, 0, 50);
            scene.alignIn.BottomCenter(playBtn, textBG, 0, 210);
        }
        scene.addResize(this.resize);

        // Tween in -----
        overlay.alpha = 0;
        character.y += 1000;
        popupContainer.x += scene.viewport.width;

        scene.tweens.add({
            targets: overlay,
            alpha: 0.8,
            duration: 1000,
        });

        scene.tweens.add({
            targets: character,
            y: character.y - 1000,
            duration: 1000,
            ease: Phaser.Math.Easing.Quadratic.InOut,
        });

        scene.tweens.add({
            targets: popupContainer,
            x: popupContainer.x - scene.viewport.width,
            duration: 1000,
            ease: Phaser.Math.Easing.Quadratic.InOut,
        });
	}

    destroy(): void {
        this.scene.removeResize(this.resize);
        super.destroy();
    }

    exit(): void{
        if (this.onExit) this.onExit.call(this.onExit, this.context);
    }

}